export const ONE_OFF_OPTION = {
  __typename: "ONE_OFF_OPTION" as const,
};

export const CREATE_REUSABLE_OPTION = {
  __typename: "CREATE_REUSABLE_OPTION" as const,
};
